import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../@AppService/Services/loader-service.service';
import { finalize, tap } from 'rxjs';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  const currentUrl = router.url;

  const shouldSkipLoading =
    currentUrl.startsWith('/home') &&
    (req.url.includes('api/events') ||
      req.url.includes('api/ComplexAttachements') ||
      req.url.includes('api/dspace') ||
      req.url.includes('api/news'));

  if (!shouldSkipLoading) {
    loadingService.show();
  }

  return next(req).pipe(
    tap({
      next: () => {
        if (!shouldSkipLoading) loadingService.isError.next(false);
      },
      error: () => {
        if (!shouldSkipLoading) loadingService.isError.next(true);
      },
    }),
    finalize(() => {
      if (!shouldSkipLoading) {
        loadingService.hide();
      }
    })
  );
};
